import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {useNavigate} from "react-router-dom";
import SecondaryButton from "../../components/SecondaryButton";
import { Policy } from "../../objects/policy";
import { RatingResponse } from "../../objects/rating";
import { PaymentIntent, StripeElementsOptionsClientSecret, loadStripe } from '@stripe/stripe-js';
import { Elements } from "@stripe/react-stripe-js";
import PaymentForm from "../../components/payments/paymentform";
import { PaymentService } from "../../services/paymentservice";
import { QuoteService } from "../../services/quoteservice";
import { StripeService } from "../../services/stripeservice";
import Backdrop from '@mui/material/Backdrop';
import Snackbar from "@mui/material/Snackbar/Snackbar";
import { Alert } from "@mui/lab";
import CircularProgress from '@mui/material/CircularProgress';

import { logActivityAsync } from "../../objects/events/loadEvents";
import dayjs from "dayjs";
import { Breadcrumbs } from "@mui/material";
import JsonService from "../../services/jsonService";
import { AddToBillingRequest } from "../../objects/addToBillingRequest";

function Payment(props:any){
    var stripeService = new StripeService();
    var paymentService = new PaymentService();
    var quoteService = new QuoteService();
    
    
    const currencyFormatter = new Intl.NumberFormat('en-US',
    {
        style: 'currency',
        currency: 'USD'
    });

    var navigate = useNavigate();
    const dispatch = useDispatch();

    const policyStore = useSelector((state: any)=> state.policyReducer) as Policy;
    var ratedPolicyStore = useSelector((state:any)=> state.ratedPolicyReducer as RatingResponse);
    const rateCycle = useSelector((state:any)=>state.rateCycleReducer) as string;

    const [isPageLoad, setIsPageLoad] = useState(true);
    const [policy, setPolicy] = useState<Policy>(new Policy());
    const [ratedQuote, setRatedQuote] = useState<RatingResponse>(new RatingResponse());
    const [zip, setZip] = useState<string>("");

    const [open, setOpen] = useState(false);
    const [isOpenErrorAlert, setIsOpenErrorAlert] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const [clientSecret, setClientSecret] = useState<string>("");
    const [stripeOptions, setStripeOptions] = useState<StripeElementsOptionsClientSecret>();
    const [customerId, setCustomerId] = useState<string>();
    const stripePromise = loadStripe(process.env.REACT_APP_INTEGRATION_STRIPE_KEY ?? "");
    
    useEffect(() => {
        (async () => {
            await logActivityAsync(policy?.policyNumber ?? "", {
                recordKey: policy?.policyNumber,
                transactionDate: dayjs(new Date().toUTCString()).toISOString(),
                action: "add_activity",
                subject: "Navigation",
                message: "Insured has navigated to the payments screen",
                isException:false,
                error: "",
                level:"INFO",
                isSent: false
            });
        })();
    }, []);

    useEffect(()=>{
        if(policyStore === undefined || policyStore == null) {
            navigate("/" + window.location.search);
        }

        if(isPageLoad) {  
            
            window.scrollTo(0, 0);
            setPolicy(policyStore);
            setRatedQuote(ratedPolicyStore);

            (async ()=>{
                
                stripePromise.then((data)=>{
                    
                }).catch((data)=> {
                    
                }).finally(()=>{
                    
                });

                var paymentIntentResponse = await stripeService.createPaymentIntent(rateCycle,
                    ratedPolicyStore.downPayment, 
                    `Quote# ${policyStore.policyNumber} - ${policyStore.emailAddress}`,
                    policyStore.policyNumber,
                    policyStore.emailAddress,
                    `${policyStore?.insuredFirstName} ${policyStore?.insuredLastName}`
                );

                    
                if(!paymentIntentResponse.ok){
                    var errorObject = JsonService.parseObject(await paymentIntentResponse.text());

                    await logActivityAsync(policyStore?.policyNumber ?? "", {
                        recordKey: policyStore?.policyNumber,
                        transactionDate: dayjs(new Date().toUTCString()).toISOString(),
                        action: "error_activity",
                        subject: "Payment Screen - Initializing Payment Intent",
                        message: `Quote# ${policyStore?.policyNumber} - ${policyStore?.insuredFirstName} ${policyStore?.insuredLastName}, ${policyStore?.emailAddress ?? "NO EMAIL"}`,
                        isException: true,
                        error: errorObject?.message ?? "Empty Response",
                        level: "ERROR",
                        isSent: false
                    });

                    var queryParams = new URLSearchParams(window.location.search);
                    queryParams.set("returnUrl", "/payment");            
                    navigate("/error?" + queryParams.toString());

                    return;
                }
                
                var clientSecretResponse = await paymentIntentResponse.json();
                var stripeSecret = clientSecretResponse.clientSecret;
                setCustomerId(clientSecretResponse.customerId);
                
                console.log({paymentIntentResponse: clientSecretResponse});

                setClientSecret(stripeSecret);
    
                setStripeOptions({
                    clientSecret: stripeSecret,
                    appearance: {
                        theme: "stripe"
                    }
                } as StripeElementsOptionsClientSecret);
            })();
            setIsPageLoad(false);
        }

        var mailingAddress = policyStore?.addresses?.filter((e)=>{
            return e.type === "mailing"
        })[0];

        setZip((mailingAddress?.zip ?? ""));
    }, []);


    function NavigateBack(){
        navigate("/questions" + window.location.search);
    }

    function NavigateForward(){    
        (async ()=> {
            navigate("/complete" + window.location.search);
        })();        
    }

      var paymentOptions = {
        wallets: {
            googlePay: "never",
        },
        fields: {
            billingDetails: {
                name: "auto"
            }
        },
        layout: "tabs",
        defaultValues: {
            billingDetails: {
                name: `${policyStore.insuredFirstName} ${policyStore.insuredLastName}`,
                address:{
                    postal_code: zip
                }
            }
        }
      };

      function onSuccess(paymentIntent: PaymentIntent){
        (async ()=>{
            try{
                var intentId = (paymentIntent?.id ?? "");

                if(intentId === "") {
    
                    setOpen(false);
                }
    
                console.log({onSuccess_paymentintent: paymentIntent});

                setOpen(true);
                var intentJson = await stripeService.getPaymentIntent(intentId, rateCycle);
                
                console.log({get_api_paymentintent: intentJson});

                if(!intentJson.ok) {
                    var errorObject = JsonService.parseObject(intent.error);
    
                    await logActivityAsync(policy?.policyNumber ?? "", {
                        recordKey: policy?.policyNumber,
                        transactionDate: dayjs(new Date().toUTCString()).toISOString(),
                        action: "error_activity",
                        subject: "Payment Screen - Get Payment Intent Exception",
                        message: `Quote# ${policy?.policyNumber} - ${policy?.insuredFirstName} ${policy?.insuredLastName}, ${policy?.emailAddress ?? "NO EMAIL"}`,
                        isException: true,
                        error: errorObject?.message ?? "Empty Response",
                        level: "ERROR",
                        isSent: false
                    });
    
                    var queryParams = new URLSearchParams(window.location.search);
                    queryParams.set("returnUrl", "/payment");            
                    navigate("/error?" + queryParams.toString());
    
                    return;
                }
    
                var intent = intentJson.data;

                var transactionId = intent.transactionId;
                var tokenId = intent.transactionId;
                var ccLastFour = intent.paymentMethod.lastFour;
                var ccExpDate = intent.paymentMethod.expirationMonth + "/1/" + intent.paymentMethod.expirationYear;
    
                console.log({intent:intent});
                var saveResult = await paymentService.savePayment("QUOTE", 
                                            ratedPolicyStore?.policyNumber,
                                            "CC", 
                                            ratedPolicyStore?.downPayment, 
                                            transactionId,
                                            tokenId,
                                            ccLastFour,
                                            ccExpDate);
    
                if(!saveResult.ok){
                    var errorObject = JsonService.parseObject(await saveResult.text());
    
                    await logActivityAsync(policy?.policyNumber ?? "", {
                        recordKey: policy?.policyNumber,
                        transactionDate: dayjs(new Date().toUTCString()).toISOString(),
                        action: "error_activity",
                        subject: "Payment Screen - Saving Payment",
                        message: `Quote# ${policy?.policyNumber} - ${policy?.insuredFirstName} ${policy?.insuredLastName}, ${policy?.emailAddress ?? "NO EMAIL"}`,
                        isException: true,
                        error: errorObject?.message ?? "Empty Response",
                        level: "ERROR",
                        isSent: false
                    });
    
                    var queryParams = new URLSearchParams(window.location.search);
                    queryParams.set("returnUrl", "/payment");            
                    navigate("/error?" + queryParams.toString());
    
                    return;
                }

                var addToBillingRequest = {
                    policyNumber: ratedPolicyStore.policyNumber,
                    accountDetails: [
                        {
                            transactionType: "RECURRING",
                            paymentType: "CC",
                            paymentToken: customerId,
                            creditCardLastFour: ccLastFour,
                            creditCardExpirationDate: ccExpDate
                        },
                        {
                            transactionType: "DOWNPAY",
                            paymentType: "CC",
                            paymentToken: customerId,
                            creditCardLastFour: ccLastFour,
                            creditCardExpirationDate: ccExpDate
                        }
                    ]

                } as AddToBillingRequest;

                console.log("add to billing request")
                var addResult = await quoteService.addToBilling(addToBillingRequest);
                console.log("attach to customer request")
                console.log({attach_payment_method: paymentIntent.payment_method});
                var attachResult = await paymentService.attachToCustomer(customerId ?? "", paymentIntent.payment_method?.toString() ?? "", rateCycle);

                policy.policyNumber = ratedPolicyStore.policyNumber;
                
                var esignatureResult = await quoteService.requestEsignature(policy);
    
                if(!esignatureResult.ok){
                    var errorObject = JsonService.parseObject(await esignatureResult.text());
    
                    await logActivityAsync(policy?.policyNumber ?? "", {
                        recordKey: policy?.policyNumber,
                        transactionDate: dayjs(new Date().toUTCString()).toISOString(),
                        action: "error_activity",
                        subject: "Payment Screen - Requesting Esignature",
                        message: `Quote# ${policy?.policyNumber} - ${policy?.insuredFirstName} ${policy?.insuredLastName}, ${policy?.emailAddress ?? "NO EMAIL"}`,
                        isException: true,
                        error: errorObject?.message ?? "Empty Response",
                        level: "ERROR",
                        isSent: false
                    });
    
                    var queryParams = new URLSearchParams(window.location.search);
                    queryParams.set("returnUrl", "/payment");            
                    navigate("/error?" + queryParams.toString());
    
                    return;
                }
    
                var issueResponse = await quoteService.issuePolicy(policy);
    
                if(!issueResponse.ok) {
                    var errorObject = JsonService.parseObject(await issueResponse.text());
    
                    await logActivityAsync(policy?.policyNumber ?? "", {
                        recordKey: policy?.policyNumber,
                        transactionDate: dayjs(new Date().toUTCString()).toISOString(),
                        action: "error_activity",
                        subject: "Payment Screen - Issue Policy",
                        message: `Quote# ${policy?.policyNumber} - ${policy?.insuredFirstName} ${policy?.insuredLastName}, ${policy?.emailAddress ?? "NO EMAIL"}`,
                        isException: true,
                        error: errorObject?.message ?? "Empty Response",
                        level: "ERROR",
                        isSent: false
                    });
    
                    var queryParams = new URLSearchParams(window.location.search);
                    queryParams.set("returnUrl", "/payment");            
                    navigate("/error?" + queryParams.toString());
                    return;
                }
    
                var issuePolicyJson = await issueResponse.json();
                var issuedPolicyNumber = issuePolicyJson.policyNumber;
    
                await logActivityAsync(policy?.policyNumber ?? "", {
                    recordKey: policy?.policyNumber,
                    transactionDate: dayjs(new Date().toUTCString()).toISOString(),
                    action: "add_activity",
                    subject: "Issued Policy",
                    message: `Quote ${policy.policyNumber} has been issued as ${issuedPolicyNumber}`,
                    isException:false,
                    error: "",
                    level:"INFO",
                    isSent: false
                });
    
                var cpolicy = {...policy};
                cpolicy.policyNumber = issuedPolicyNumber;
                
                dispatch({type: "ISSUED_QUOTE", payload: issuePolicyJson })
    
                NavigateForward();
                setOpen(false);
            }catch(err: any){

                await logActivityAsync(policy?.policyNumber ?? "", {
                    recordKey: policy?.policyNumber,
                    transactionDate: dayjs(new Date().toUTCString()).toISOString(),
                    action: "error_activity",
                    subject: "Payment Screen - Processing Payment Intent",
                    message: `Quote# ${policy?.policyNumber} - ${policy?.insuredFirstName} ${policy?.insuredLastName}, ${policy?.emailAddress ?? "NO EMAIL"}`,
                    isException: true,
                    error: err ?? "Empty Response",
                    level: "ERROR",
                    isSent: false
                });

            }
        })();
      };
      
    return (
         
        <>
            <div className="container-add-vehicle w-100 pt-10">
                
                <div className="w-[90vw] m-auto sm:w-[90vw] md:w-[90vw] lg:w-[90vw] xl:w-[60vw]">
                    <Breadcrumbs>
                        <h3 className="text-2xl pb-5 mt-0">Step 7 of 7</h3>
                    </Breadcrumbs>
                    <h3 className="text-lg font-semibold">Due Today {currencyFormatter.format(ratedPolicyStore?.downPayment ?? 0 )}</h3>
                    <h3 className="text-3xl font-light mt-8 mb-10 w-full">To complete your purchase, please enter your credit card information</h3>  

                    {clientSecret && (<Elements stripe={stripePromise}  options={stripeOptions}>
                    
                    <PaymentForm options={paymentOptions} 
                        onStripeSuccess={ onSuccess } 
                        setOpenSpinner={()=>{setOpen(true)}} 
                        setCloseSpinner={()=>{setOpen(false)}} 
                        policyObject={policy}/>                        
                
                </Elements>)}
                    
                </div>
            </div>
        
            <div className="mb-5  mt-28 p-5 bg-[#e0e1dd]">
                <div className="m-auto w-[90vw] sm:w-[90vw] md:w-[90vw] lg:w-[60vw] xl:w-[60vw]">                    
                    <SecondaryButton onClick={NavigateBack} variant="contained" className="p-2 w-1/3 sm:w-1/3 md:w-1/6 lg:w-1/6 xl:w-1/6 ">Back</SecondaryButton>
                    {/* <Button variant="contained" className="btn-continue hover:cursor-pointer w-1/3 sm:w-1/3 md:w-1/6 lg:w-1/6 xl:w-1/6  float-right bg-[#0071eb] text-[#ffffff] rounded-md active:bg-[#0a58ca]" onClick={NavigateForward}>Continue</Button> */}
                    <div className="clear-both">
                        
                    </div>
                </div>
            </div>

           

            <Backdrop
                
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={open}
                onClick={()=>{  }}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <Snackbar open={isOpenErrorAlert} 
            autoHideDuration={6000} 
            onClose={(e)=>{ setIsOpenErrorAlert(false)}} 
            anchorOrigin={ { vertical:"top", horizontal:"right" }}>
                <Alert onClose={(e)=>{ setIsOpenErrorAlert(false)}} severity="error" sx={{ width: '100%' }}>
                    {errorMessage}
                </Alert>
            </Snackbar>
        </>
    );
}

export default Payment;